var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentArea',{staticClass:"col-start-1 col-span-6"},_vm._l((_vm.images),function(image,i){return _c('div',{key:i,staticClass:"text-left transition-opacity",class:[
      _vm.span,
      {
        'opacity-0': !_vm.imageLoaded,
        'center-last-image': i === 2
      }
    ]},[_c('CoreImage',{staticClass:"w-full",attrs:{"sizes":_vm.sizes,"image":image.image[0]},on:{"load":function($event){_vm.imageLoaded = true}}}),_c('ContentCaption',{attrs:{"captionItem":image.captionItem,"captionBrand":image.captionBrand}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }